import axios from 'axios';
import Cookies from 'universal-cookie';

const initialState = {
    accounts: [],
};

// Action Types
const GET_ACCOUNTS = 'GET_ACCOUNTS';
const POST_ACCOUNT = 'POST_ACCOUNT';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

// Reducer
export default function AccountReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ACCOUNTS:
            return { ...state, accounts: action.payload };
        case POST_ACCOUNT:
            return { ...state, accounts: [...state.accounts, action.payload] };
        case UPDATE_ACCOUNT:
            return {
                ...state,
                accounts: state.accounts.map(a =>
                    a.id === action.payload.id ? { ...a, ...action.payload } : a
                ),
            };
        case DELETE_ACCOUNT:
            return {
                ...state,
                accounts: state.accounts.map(a =>
                    a.id === action.payload ? { ...a, active: false } : a
                ),
            };
        default:
            return state;
    }
}

// Action Creators
export const SetAccounts = (accounts) => ({ type: GET_ACCOUNTS, payload: accounts });
export const PostAccount = (account) => ({ type: POST_ACCOUNT, payload: account });
export const UpdateAccount = (account) => ({ type: UPDATE_ACCOUNT, payload: account });
export const DeleteAccount = (id) => ({ type: DELETE_ACCOUNT, payload: id });

const getHeaders = () => {
    const cookies = new Cookies();
    return { headers: { Authorization: `Bearer ${cookies.get('token')}` } };
};

// Thunks
export const fetchAccountsFromAPI = () => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/Account/GetAll', getHeaders());
        dispatch(SetAccounts(response.data));
    } catch (error) {
        console.error('Error fetching accounts:', error);
    }
};

export const createAccountInAPI = (account) => async (dispatch) => {
    try {
        const response = await axios.post(window.API_BASE_URL + '/Account', account, getHeaders());
        dispatch(PostAccount(response.data));
    } catch (error) {
        console.error('Error creating account:', error);
    }
};

export const updateAccountInAPI = (account) => async (dispatch) => {
    try {
        const response = await axios.put(`${window.API_BASE_URL}/Account/${account.id}`, account, getHeaders());
        dispatch(UpdateAccount(response.data));
    } catch (error) {
        console.error('Error updating account:', error);
    }
};

export const deleteAccountFromAPI = (id) => async (dispatch) => {
    try {
        await axios.delete(`${window.API_BASE_URL}/Account/${id}`, getHeaders());
        dispatch(DeleteAccount(id));
    } catch (error) {
        console.error('Error deleting account:', error);
    }
};
